import {
  ADD_TOKEN,
  ADD_ID,
  ADD_LANG,
  ADD_LOGIN,
  ADD_RESET,
  ADD_REGISTER,
  ADD_SELECTED_USER_TYPE,
  SET_ENV,
} from '../constants/AppConstants';

export const addToken = token => ({
  type: ADD_TOKEN,
  payload: {
    token,
  },
});

export const addId = id => ({
  type: ADD_ID,
  payload: {
    id,
  },
});

export const addLanguage = lang => ({
  type: ADD_LANG,
  payload: {
    lang,
  },
});

export const addLogin = login => ({
  type: ADD_LOGIN,
  payload: {
    login,
  },
});

export const addReset = reset =>({
  type: ADD_RESET,
  payload: {
    reset,
  },
});

export const addRegister = register => ({
  type: ADD_REGISTER,
  payload: {
    register,
  },
});

export const addSelectedUserType = userType => ({
  type: ADD_SELECTED_USER_TYPE,
  payload: {
    userType,
  },
});

export const setEnv = env => ({
  type: SET_ENV,
  payload: {
    env,
  },
});



// WEBPACK FOOTER //
// ./src/actions/AppActions.js